import { FloatingLabel, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { v4 as uuid } from "uuid";
import ITextFieldProps from "./IFloatingTextFieldProps";
import { IsValid, ValidationCssClass } from "../Validation";
import styles from "../formFields.module.scss";
import { mergeStyles } from "@fluentui/merge-styles";

export default function FloatingTextField(props: ITextFieldProps) {
    const { t } = useTranslation();

    const validationMessage = props.validationMessage || t("general.provideValue");
    const bottomMargin = props.bottomMargin ?? 3;
    
    let validationCssClass = ValidationCssClass(props.validation);
    let isValid = IsValid(props.validation);

    const floatingLabelCssClass = mergeStyles(`mb-${bottomMargin}`, props.required ? styles.required : null);

    return (
        <FloatingLabel  className={floatingLabelCssClass}
                        controlId={`txt-${uuid()}`}
                        label={props.label}>
            <Form.Control   type={props.type}
                            placeholder={props.placeholder}
                            className={`${validationCssClass} ${styles.formControl}`}
                            value={props.value}
                            isValid={isValid}
                            disabled={props.disabled}
                            required={props.required}
                            onChange={(e) => props.onChange(e.target.value)}
                            />
            {
                isValid === false &&
                <div className="text-danger">
                    {validationMessage}
                </div>
            }
        </FloatingLabel>
    );
}